<template>
    <form action="">
        <div class="modal-card" style="width: 50em">
            <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
            <header class="modal-card-head">
                Registro
            </header>
            <section class="modal-card-body">
                <b-field label="Nombre">
                    <b-input
                        type="text"
                        :value="user.name"
                        v-model="user.name"
                        placeholder="Nombre"
                        required
                    ></b-input>
                </b-field>
                <b-field label="Apellido Paterno">
                    <b-input
                        type="text"
                        :value="user.pather_lastname"
                        v-model="user.pather_lastname"
                        placeholder="Apellido Paterno"
                        required
                    ></b-input>
                </b-field>
                <b-field label="Apellido Materno">
                    <b-input
                        type="text"
                        :value="user.mother_lastname"
                        v-model="user.mother_lastname"
                        placeholder="Apellido Materno"
                        required
                    ></b-input>
                </b-field>
                <b-field label="Rut">
                    <b-input
                        type="text"
                        :value="user.rut"
                        v-model="user.rut"
                        placeholder="RUT"
                        maxlength="9"
                        onkeypress="return validate(event)"
                        required
                    ></b-input>
                </b-field>
                <b-field label="Email">
                    <b-input
                        type="email"
                        :value="user.email"
                        v-model="user.email"
                        placeholder="Your email"
                        required
                    ></b-input>
                </b-field>
                <b-field label="Password">
                    <b-input
                        type="password"
                        :value="user.password"
                        v-model="user.password"
                        password-reveal
                        placeholder="Password"
                        required
                    ></b-input>
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">
                    Cerrar
                </button>
                <button class="button is-primary" type="button" @click="create()">
                    Guardar
                </button>
            </footer>
        </div>
    </form>
</template>
<script>
export default {

    data() {
        return {
            user:{
                name:'',
                pather_lastname:'',
                mother_lastname:'',
                rut:'',
                email:'',
                password:'',

                stablishment_id: 1,
                role_id: 3,
                stament_id:1,
                user_type_id:1,
                location_id:1
            },
            isLoading:false
        };
    },
    methods:{
        validate(event) {
            var key = event.which || event.keyCode || 0;
            return ((key >= 65 && key <= 92) ||
                (key >= 97 && key <= 124) || key==32)
        },
        async create(){
            try {
                this.isLoading=true
                await this.$http.post(`api/user`, this.user).then(
                    response => {
                        //Limpia el objeto User
                        for (const i in this.user) {
                            this.user[i] = "";
                        }
                        console.log("POST:", response.body);
                        this.toast("Registro completado", "is-success");
                        this.$parent.close()
                    },
                    response => {
                        this.toast("error al registrar", "is-danger");
                        console.log("error: ", response);
                    }
                );
                console.log(this.user)

            }catch(err){
                console.log(err)
            } finally {
                this.isLoading=false
            }
        }
    }
}
</script>
